<template>
  <div>
    <!-- Tabela principal -->
    <div v-if="listaAtributo !== null && listaAtributo.corpo.length > 0">
      
      <table class="table table-striped listaAtributo tabela-fixa">
        <thead>
          <tr>
            <th class="col-parametros">Parâmetros</th>
            <th class="col-tipo">Tipo</th>
            <th class="col-obrigatorio"><span v-if="!saida">Obrigatório</span></th>
            <th class="col-descricao">Descrição</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in listaAtributo.corpo" :key="item.indexAtributo">
            <td>
              {{ item.nome }}
              <button v-if="item.lupa === true" @click="abrirModalComDados($event, item, linhaCodigo)"
                title="ver detalhes">
                <i class="fa-sharp fa-solid fa-magnifying-glass"></i>
              </button>
            </td>
            <td>{{ item.formato }}</td>
            <td class="celula-centro">
              <span v-if="!saida"><i :class="[item.obrigatorio]"></i></span>
            </td>
            <td>{{ item.descricao }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Iteração recursiva sobre os objetos -->
    <div v-for="item in listaAtributo.corpo" :key="item.indexAtributo">
      <div v-if="item.hierarquia != null && item.hierarquia.length > 0">
        <div class="mt-3">
          <span class="negrito mt-3 mb-2">
            {{ [...rotaAtributo, item.nome].join(' > ') }}
          </span> -
          <span>{{ item.descricao }}</span>
        </div>
        
        <ConsultaListaAtributoDocumentacao v-if="item.hierarquia && item.hierarquia.length > 0" 
          :tipoServico="tipoServico" :nome="item.nome"
          :descricao="item.descricao" :listaAtributo="{ corpo: item.hierarquia, listaObjetos: [] }" :saida="saida"
          :dadosModal="dadosModal" :linhaCodigo="linhaCodigo" :rotaAtributo="[...rotaAtributo, item.nome]" />
      </div>
    </div>

    <div class="modal-detalhe">
      <ModalComponent :show="showModal" @close="closeModal" :dadosModal="dadosModal"></ModalComponent>
    </div>
  </div>
</template>

<script>

import ModalComponent from "./Modal.vue";

export default {
  name: "ConsultaListaAtributoDocumentacao",
  components: {
    ModalComponent,
    ConsultaListaAtributoDocumentacao: () => import('./ConsultaListaAtributoDocumentacao.vue')
  },
  props: {
    tipoServico: {
      type: String
    },
    nome: {
      type: String,
      default: ""
    },
    descricao: {
      type: String,
      default: ""
    },
    listaAtributo: {
      type: Object,
      default: () => ({ corpo: [], listaObjetos: [] })
    },
    dadosApiServico: { 
      type: Object, 
      default: () => ({}) 
    },
    saida: {
      type: Boolean,
      default: false
    },
    linhaCodigo: {
      type: Array,
      default: () => []

    },
    rotaAtributo: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      dadosModal: {}
    };
  },
  methods: {
    ajustarLinhaCodigoModal(indexLinha, linhaCodigo) {
      const mapAux = new Map();
      var arrayAux = [];
      for (let linha of linhaCodigo) {
        if (indexLinha == linha.id) {
          mapAux.set(linha.id, linha.id);
          break;
        } else {
          if (linha.index.includes("linhaCodigoInicio-")) {
            mapAux.set(linha.id, linha.id);
            arrayAux.push(linha.id);
          } else if (linha.index.includes("linhaCodigoFim-")) {
            mapAux.delete(arrayAux[arrayAux.length - 1]);
            arrayAux.splice(-1);
          }
        }
      }
      var linhaCodigoModal = [];
      for (let linha of linhaCodigo) {
        if (mapAux.get(linha.id)) {
          linhaCodigoModal.push(linha);
        }
      }
      return linhaCodigoModal;
    },    
    abrirModalComDados(event, subItem, linhaCodigo) {
      const item = subItem;
      item.linhaCodigo = [];
      item.apresentaLinhaCodigo = false;
      if (this.tipoServico == "R" && linhaCodigo != null && (subItem.entrada === 'E' || subItem.entrada === 'S')) {
        item.linhaCodigo = this.ajustarLinhaCodigoModal(subItem.indexAtributo, linhaCodigo);
        item.apresentaLinhaCodigo = true;
      }
      item.modalTop = event.target.getBoundingClientRect().top;
      this.dadosModal = item;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    }

  },
  mounted() {

  },
  computed: {

  },
  watch: {

  }
}
</script>
<style scoped>
.tabela-fixa {
  width: 100%;
  table-layout: fixed;
}

.col-parametros {
  width: 25%;
}

.col-tipo {
  width: 10%;
}

.col-obrigatorio {
  width: 15%;
  text-align: center;
}

.col-descricao {
  width: 50%;
}

.celula-centro {
  text-align: center;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
